import {fancybox} from "@fancyapps/fancybox";
import slick from "slick-carousel";
import jQuery from 'jquery';
import WOW from 'wow.js';
import Template7 from 'template7';

// Variables
let header = document.getElementById("header");
let header_mobile = document.getElementById("mobile_header");
let hamburger = document.getElementById("hamburger");
let panier_indicateurs = document.querySelectorAll(".open_cart");
let panier = [];

// Curseur

// Menu
const megamenu = document.querySelector("#megamenu");
const megamenu2 = document.querySelector("#megamenu2");
const megamenuwrapper = document.querySelector("#megamenuwrapper");
const megamenuwrapper2 = document.querySelector("#megamenuwrapper2");
const menu_opener = document.querySelectorAll(".open_megamenu");
const menu_opener2 = document.querySelectorAll(".open_megamenu_2");
const open_search = document.querySelectorAll("li.open_search");
const fond = document.querySelector("#megamenu .fond");
const fond2 = document.querySelector("#megamenu2 .fond");
const closemega = document.querySelectorAll(".close_mega_menu");
// CART
const addtocart = document.querySelector("#addtocart");
const cart = document.querySelector(".add_to_cart_container");
const close_cart = document.querySelectorAll(".close_cart_container");
const cadre_cart = document.querySelector("#fond_cart");
// CALL
const callmeback = document.querySelector("#callmeback");
const call = document.querySelector("#call_me_back");
const close_call = document.querySelectorAll(".close_call_container");
const cadre_callme = document.querySelector("#fond_cart_callme");

// Event Listener Globaux
window.addEventListener('load', init);

// Event Listener Menu
hamburger.addEventListener('touchstart', beginTouched, {passive: true});
hamburger.addEventListener('touchend', endTouched, {passive: true});
hamburger.addEventListener('click', openMenu, {passive: true});
megamenuwrapper.addEventListener('mouseleave', closeMegaMenu, {passive: true});
megamenuwrapper2.addEventListener('mouseleave', closeMegaMenu2, {passive: true});
menu_opener.forEach( item => {
	item.addEventListener('mouseenter', openMegaMenu);
});
menu_opener2.forEach(item => {
	item.addEventListener('mouseenter', openMegaMenu2);
});
open_search.forEach(item => {
	item.addEventListener('click', openMegaMenu);
});
closemega.forEach(item => {
	item.addEventListener("click", closeMegaMenus);
})
fond.addEventListener("click", closeMegaMenu());
fond2.addEventListener("click", closeMegaMenu2());


// ES6 Functions	

function beginTouched(e) {
	header_mobile.classList.add("touched");
}
function endTouched(e) {
	header_mobile.classList.remove("touched");
}
function openMenu(e) {
	header_mobile.classList.remove("touched");
	if(header_mobile.classList.contains("opened")) {
		header_mobile.classList.remove("opened");
	} else {
		header_mobile.classList.add("opened");
	}
	
}
function closeMegaMenus() {
	closeMegaMenu();
	closeMegaMenu2();
}
function closeMegaMenu() {
	megamenu.classList.remove("visible");
	header.classList.remove("forced");
}
function closeMegaMenu2() {
	megamenu2.classList.remove("visible");
	header.classList.remove("forced");
}
function openMegaMenu() {
	closeMegaMenu2();
	megamenu.classList.add("visible");
	header.classList.add("forced");
}
function openMegaMenu2() {
	closeMegaMenu();
	megamenu2.classList.add("visible");
	header.classList.add("forced");
}
function init() {
	
}

// JQUERY
(function($) {

	function init() {
		
		// Jquery function
		window.addEventListener('scroll', onScroll, {passive: true});
		$(".slick-slider").slick({
		  dots: true,
		  fade: true,
		  infinite: true,
		  speed: 500,
		  slidesToShow: 1,
		  slidesToScroll: 1,
		  autoplay: true,
		  autoplaySpeed: 6000,
		  arrows: false,
		  pauseOnHover: false
		});	
		new WOW({
			resetAnimation: false,
			offset: 200
		}).init();
		$(".couleur").click(function() {
			$(".couleur").removeClass("selected");
			$(this).addClass("selected");
		})
		$("#ajouter_au_panier_final").click(function() {
			var nom_du_produit = $(".title").attr("data-title");
			var couleur = $(".customisation .couleur.selected").attr("data-title");
			var apercu = $(".customisation .couleur.selected").attr("data-apercu");
			var format = $("#cart_format").val();
			var epaisseur = $("#cart_epaisseur").val();
			var quantite = $("#quantite").val();
			var unite = $("#quantite").attr("data-unite");
			var ligne = {
				"titre" : nom_du_produit,
				"couleur" : couleur,
				"format" : format,
				"epaisseur" : epaisseur,
				"quantite" : quantite,
				"apercu" : apercu,
				"unite" : unite
			};
			if(localStorage.getItem("panier")) {
				var cart = localStorage.getItem("panier");
				cart = JSON.parse(cart);
				cart.push(ligne);
				localStorage.setItem("panier", JSON.stringify(cart));
			} else {
				var cart = [];
				cart.push(ligne);
				localStorage.setItem("panier", JSON.stringify(cart));
			}
			$(".buttons .before, .customisation").hide();
			$(".buttons .end").css({
				"display" : "flex"
			});
			
		});
		if($("#recap_panier").length > 0) {
			renderPanier();			
		}
		if(addtocart) {
			addtocart.addEventListener('click', openCart);
			close_cart.forEach(function(item) {
				item.addEventListener('click', closeCart);
			})
			cadre_cart.addEventListener('click', closeCart);
		}
		if(callmeback) {
			callmeback.addEventListener('click', openCallme);
			close_call.forEach(function(item) {
				item.addEventListener('click', closeCall);
			})
			cadre_callme.addEventListener('click', closeCall);
		}
		$("body").on("click", ".counter .moins", function() {
			var el = $(this);
			var quantity = el.next(".quantity");
			var quantite = parseInt(quantity.val()) - 1;
			if(quantite < 1) {
				quantite = 1;
			}
			quantity.val(quantite);
		});
		$("body").on("click", ".counter .plus", function() {
			var el = $(this);
			var quantity = el.prev(".quantity");
			var quantite = parseInt(quantity.val()) + 1;
			quantity.val(quantite);
		});
		$("body").on("click", ".cell.last .fa-times", function() {
			var line = $(this).closest(".line");
			line.remove();
			updatePanier();
			console.log('ee');
		});
		$("#send_devis").submit(function(e) {
			e.preventDefault();
			updatePanier();
			$("#send_devis #submit").css({ "display" : "none" });
			$("#send_devis .loader").css({ "display" : "block" });
			var data = {
				nom : $("#nom").val(),
				email : $("#email").val(),
				telephone : $("#telephone").val(),
				societe : $("#societe").val(),
				codepostal : $("#codepostal").val(),
				message: $("#message").val(),
				devis : generatemail($("#nom").val(), $("#email").val(), $("#telephone").val(), $("#societe").val(), $("#codepostal").val(), $("#message").val()),
			};
			$.post(
				ajaxurl,
				{
					'action': 'send_devis',
					'data': data
				},
				function(response){
					var reponse = JSON.parse(response);
					if(reponse.statut == 200) {
						$("#send_devis .reponse").empty().append(reponse.message);
						$("#send_devis .loader").css({ "display" : "none" });
						$("#send_devis .reponse").css({ "display" : "block" });
						localStorage.removeItem("panier");
						renderPanier();
					} else {
						$("#send_devis .reponse").empty().append(reponse.message);
						$("#send_devis .loader").css({ "display" : "none" });
						$("#send_devis .reponse").css({ "display" : "block" });
						$("#submit").css({ "display" : "block" });
					}
					
				}
			);
		})
		$("#callmenow").submit(function(e) {
			e.preventDefault();
			$("#callmenow .submit").css({"display" : "none"});
			$("#callmenow .loader").css({"display" : "block"});
			var data = {
				objet: $("#objet").val(),
				nom: $("#nom").val(),
				telephone: $("#telephone").val(),
				plagehoraire: $("#jour").val(),
			};
			$.post(
				ajaxurl,
				{
					'action': 'send_appel',
					'data': data,
				},
				function(response){
					var reponse = JSON.parse(response);
					if(reponse.statut == 200) {
						$("#callmenow .reponse").empty().append(reponse.message);
						$("#callmenow .loader").css({"display" : "none"});
						$("#callmenow .reponse").css({"display" : "block"});
					} else {
						$("#callmenow .reponse").empty().append(reponse.message);
						$("#callmenow .loader").css({"display" : "none"});
						$("#callmenow .reponse").css({"display" : "block"});
						$("#callmenow .submit").css({"display" : "block"});
					}
					
				}
			);
		})
		$(".produit-body .couleurs .couleur").eq(0).bind("click");
	}
	function openCallme() {
		call.classList.add("visible");
	}
	function openCart() {
		cart.classList.add("visible");
	}
	function managePanier() {
		var paniers = $(".open_cart");
		paniers.each(function() {
			var el = $(this);
			var span = el.find("span");
			if(localStorage.getItem("panier")) {
				var cart = localStorage.getItem("panier");
				cart = JSON.parse(localStorage.getItem("panier"));
				span.empty().append("(" + cart.length + ")");
			} else {
				span.empty().append("(0)");
			}
			
		})
	}
	function closeCart() {
		cart.classList.remove("visible");
		$(".buttons .before, .customisation").show();
		$(".buttons .end").css({
			"display" : "none"
		});
	}
	function closeCall() {
		call.classList.remove("visible");
	}
	function initCursorInteraction() {
		$("a, input, button, .link, .add_to_cart_container .buttons a, .add_to_cart_container .close_cart_container, .close_call_container, .cell .fa-times, .counter .plus, .counter .moins").hover(function() {
			dotCursor.classList.add("big");
			circleCursor.classList.add("big");
		}, function() {
			dotCursor.classList.remove("big");
			circleCursor.classList.remove("big");
		})
		
		$(".add_to_cart_container .fond").hover(function() {
			dotCursor.classList.add("close");
			circleCursor.classList.add("close");
		}, function() {
			dotCursor.classList.remove("close");
			circleCursor.classList.remove("close");
		})
	}
	function renderPanier() {
		managePanier();
		$("#lines_cart").empty();
		var template = $('#lines_template').html();
		var compiledTemplate = Template7.compile(template);
		var cart = localStorage.getItem("panier");
		cart = JSON.parse(cart);
		if(cart) {
			var position = 0;
			cart.forEach(function(item) {
				item.position = position;
				var html = compiledTemplate(item);
				$("#lines_cart").append(html);
				position++;
			});
		} else {
			$("#lines_cart").append("<p>Votre demande de devis est tristement vide.</p>");
		}
	}
	function updatePanier() {
		
		if($("#lines_cart .line").length) {
			var cart = [];
			$("#lines_cart .line").each(function() {
				var el = $(this);
				var ligne = {
					"titre" : el.find(".infos .titre").attr("data-value"),
					"couleur" : el.find(".infos .couleur").attr("data-value"),
					"format" : el.find(".infos .taille").attr("data-value"),
					"epaisseur" : el.find(".infos .epaisseur").attr("data-value"),
					"quantite" : el.find(".quantity").val(),
					"apercu" : el.find(".image").attr("data-value"),
					"unite" : el.find("label").attr("data-value")
				};
				cart.push(ligne);
			})
			localStorage.setItem("panier", JSON.stringify(cart));
		} else {
			localStorage.removeItem("panier");
		}
		
		renderPanier();
		
	}
	function generatemail(nom, email, telephone, societe, codepostal, message) {
		var template = $('#mail_template').html();
		var compiledTemplate = Template7.compile(template);
		var cart = localStorage.getItem("panier");
		cart = JSON.parse(cart);
		var lines = {
			nom: nom,
			email: email,
			telephone: telephone,
			societe: societe,
			codepostal: codepostal,
			message: message,
			cart
		};
		console.log(lines);
		var html = compiledTemplate(lines);
		return html;
	}
	function onScroll(e) {

		// Gestion du header
		if(window.scrollY >= window.innerHeight) {
			header.classList.add("scrolled");
		} else {
			header.classList.remove("scrolled");
		}
		
		if($("body").hasClass("single-produit")) {
			var headerHeight = $("#header").height();
			var principalHeight = $(".principal").height();
			if(window.scrollY >= (headerHeight + principalHeight)) {
				$(".principal").addClass("sticky");
			} else {
				$(".principal").removeClass("sticky");
			}
		}
		
		
	}	
	init();
	managePanier();
	
})( jQuery );